import Image from 'next/legacy/image';
import React from 'react';

import { MacrosContainer } from '@/components/common/MacrosContainer/MacrosContainer';
import { useMediaQuery } from '@/hooks';

type CardProps = {
  children?: React.ReactNode;
  title: string;
  imageSrc: string;
  icon?: string;
  productType?: string;
  price?: number;
  wasPrice?: number;
  weight?: number;
  unit?: string;
  onClick?: () => void;
  titleStyle?: {};
  customStyle?: boolean;
  isWlp?: boolean;
  isMeals?: boolean;
  nutritionalInfo?: any;
};

export const Card: React.FC<CardProps> = ({
  children,
  title,
  imageSrc,
  icon = '',
  productType,
  price = 0,
  wasPrice = 0,
  weight = 0,
  unit = 'g',
  titleStyle,
  customStyle,
  onClick,
  isWlp = false,
  isMeals = false,
  nutritionalInfo,
}) => {
  const baseStyle = {
    container: 'lg:w-40 lg:flex-col',
    widthResponsive: 'md:w-2/4 lg:w-full',
    title: 'md:text-lg lg:text-sm',
  };
  const customStyles = {
    container: 'md:flex-col',
    widthResponsive: 'md:w-full',
    title: 'text-sm md:text-base',
  };
  const style = customStyle ? customStyles : baseStyle;
  const isSMDevice = useMediaQuery(`(max-width:1023px)`);
  return (
    <>
      <div
        className={`relative flex h-full min-w-[174px] overflow-hidden rounded-xl bg-off-white ${style.container}`}
      >
        <div className="absolute left-0 top-0 z-10 flex p-2">
          <p
            className={`${
              !productType && 'hidden'
            } rounded-xl bg-[#1b6dbe99]  px-2 font-interMedium text-sm capitalize text-white`}
          >
            <span>{productType}</span>
          </p>
        </div>
        <div
          className={`relative inline-block cursor-pointer ${
            isWlp
              ? 'w-[80px] lg:w-full'
              : `w-3/4 md:pb-3 ${style.widthResponsive}`
          }`}
          onClick={onClick}
        >
          <div>
            <Image
              src={imageSrc}
              alt={title}
              width={200}
              height={200}
              className="object-cover md:object-contain"
              layout="responsive"
            />
          </div>
          <div
            className={`${
              !icon && 'hidden'
            } absolute bottom-0 left-0 flex h-5 w-6 items-center justify-center rounded-tr-md bg-primary`}
          >
            {icon && <Image width={18} height={12} src={icon} alt="icon" />}
          </div>
          <div className="absolute bottom-0 flex w-full">
            <MacrosContainer nutritionalInfo={nutritionalInfo} />
          </div>
        </div>

        {!isWlp && (
          <div
            className={`relative inline-block h-auto px-4 py-2 align-top md:h-full ${
              isWlp
                ? 'w-[65%] md:w-[78%] lg:w-full'
                : `w-3/4 ${style.widthResponsive}`
            }`}
          >
            <div
              className={`line-clamp-2 font-interMedium md:mb-2 ${
                !isWlp
                  ? 'text-sm lg:text-base'
                  : 'font-interMedium text-sm lg:text-xs'
              } leading-[22px] ${!isWlp && style.title} ${titleStyle}`}
            >
              {title}
            </div>
            <div className="flex flex-col md:flex-row md:items-baseline md:justify-between">
              <div className="order-last md:order-none md:mt-1">
                <span
                  style={{ color: '#008A22' }}
                  className={`${
                    price === 0 && 'hidden'
                  } w-20 font-interSemibold text-sm leading-[18px] md:mr-2 md:py-1 md:text-base md:leading-[22px]`}
                >
                  {`$${price.toFixed(2)}`}
                </span>
                {wasPrice > price ? (
                  <span className="px-2 text-xs leading-4 text-grey-dark line-through md:px-0 lg:text-sm">
                    ${wasPrice?.toFixed(2)}
                  </span>
                ) : null}
              </div>
              <div className="order-first md:order-none">
                <span
                  className={`${
                    weight === 0 && 'hidden'
                  } xs:leading-8 font-interMedium text-sm text-grey-dark md:py-1 lg:font-interMedium`}
                >{`${weight} ${unit}`}</span>
              </div>
            </div>
            {!isWlp && <div className="flex h-full flex-col">{children}</div>}
          </div>
        )}
        {isWlp && (
          <div
            className={`flex ${
              isSMDevice ? 'w-3/4 justify-between' : 'flex-col'
            } py-[26px] md:items-center md:py-0 lg:w-full lg:p-2`}
          >
            <div
              className={`mb-3 line-clamp-2 min-h-[34px] w-[180px] pl-[18px] font-interMedium text-sm leading-[18px] md:w-full lg:pl-0 lg:text-xs ${
                isMeals && 'lg:mb-10'
              }`}
            >
              {title}
            </div>
            <div className={`lg:absolute lg:bottom-2 ${isSMDevice && 'pr-2'}`}>
              {children}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
